import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-categories-style-three',
  templateUrl: './categories-style-three.component.html',
  styleUrls: ['./categories-style-three.component.scss']
})
export class CategoriesStyleThreeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
